import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchQuestionnaireCard({ languageId, caseManagerId }) {
  return axiosRequest(
    'get',
    serviceUrls.QUESTIONNAIRE_GET_CARD,
    {
      languageId,
      caseManagerId,
    },
    { timeout: 180000 },
  );
}

export function fetchQuestionnaireIntro({ entityId, organizerTypeId, yearTypeId, languageId }) {
  return axiosRequest(
    'get',
    serviceUrls.QUESTIONNAIRE_GET_INTRO,
    {
      entityId,
      organizerTypeId,
      yearTypeId,
      languageId,
    },
    { timeout: 180000 },
  );
}
export function fetchQuestionnaireDataCollectPage({ entityId, pageId, organizerTypeId, yearTypeId }) {
  return axiosRequest(
    'get',
    serviceUrls.QUESTIONNAIRE_GET_DATA_COLLECT_PAGE,
    {
      entityId,
      pageId,
      organizerTypeId,
      yearTypeId,
    },
    { timeout: 180000 },
  );
}

export function fetchQuestionnairePage({ entityId, pageId, organizerTypeId, yearTypeId }) {
  return axiosRequest(
    'get',
    serviceUrls.QUESTIONNAIRE_GET_PAGE,
    {
      entityId,
      pageId,
      organizerTypeId,
      yearTypeId,
    },
    { timeout: 180000 },
  );
}

export function getQuestionnaireProfileById(questionnaireId) {
  return axiosRequest('get', serviceUrls.QUESTIONNAIRE_PROFILE, { questionnaireId }, { timeout: 180000 });
}
export function getReviewSummaryHtml(id) {
  return axiosRequest('get', serviceUrls.QUESTIONNAIRES_GET_REVIEW_SUMMARY_HTML, { id });
}
export function fetchQuestionnaireSection({ entityId, organizerTypeId, yearTypeId, languageId, sectionName }) {
  return axiosRequest(
    'get',
    serviceUrls.QUESTIONNAIRE_GET_SECTION,
    {
      entityId,
      organizerTypeId,
      yearTypeId,
      languageId,
      sectionName,
    },
    { timeout: 180000 },
  );
}

export function saveCaseDataCollectQuestionnairePage(body = {}) {
  return axiosRequest('post', serviceUrls.QUESTIONNAIRE_CASEDATACOLLECT_SAVE_PAGE, body);
}

export function fetchCaseMenu(caseId, isAllCases) {
  return axiosRequest(
    'get',
    serviceUrls.CASES_GET_MENU,
    {
      caseId,
      isAllActionSelected: isAllCases,
    },
    { timeout: 180000 },
  );
}

export function refreshQuestionnaire(QuestionnaireId, SectionId) {
  return axiosRequest(
    'post',
    serviceUrls.CASES_GET_REFERESH_QUESTIONNAIRE,
    {
      AllSections: false,
      QuestionnaireId,
      SectionId,
    },
    { timeout: 180000 },
  );
}
